import { useContext, useEffect, useState } from 'react'
import { PromotedBranchContext } from '../context/context'
import { Trash } from '@styled-icons/boxicons-solid'

import RadioButton from '../../common/RadioButton'
import CheckBox from '../../common/CheckBox'
import InputText from '../../common/InputText'
import { getRequest, postRequest } from '../../../services/base'
import Tooltip from '../../common/tooltip'
import useDebouncedValue from '../../../utils/common_function'
import NoRecordsFound from '../../common/NoRecordsFound'
import { CheckCircle } from '@styled-icons/boxicons-solid'
import Button from '../../common/Button'
import { NavContext } from '../../../context/global_context'
import { useParams, useSearchParams } from 'react-router-dom'
import ErrorCard from '../../common/ErrorCard'
import DownloadDeleteFileLogBtn from './download_logs_btn'

const DeletePromotedFiles = () => {
  const { vehicle, branch } = useParams()

  const [state, dispatch] = useContext(PromotedBranchContext)
  const [navState, navDispatch] = useContext(NavContext)
  const [searchParams, setSearchParams] = useSearchParams()

  const [section, setSection] = useState(null)
  const [sectionData, setSectionData] = useState([])
  const [filteredData, setFilteredData] = useState([])
  const [searchValue, setSearchValue] = useState(null)
  const debouncedToSearchValue = useDebouncedValue(searchValue, 500)
  const [selectedFolders, setSelectedFolders] = useState({
    connector_views: [],
    power_distribution: [],
    vehicle_views: [],
    visual_aid: [],
    device_layout: [],
  })
  const [selectAll, setSelectAll] = useState(false)
  const [showBarnchNotFound, setBarnchNotFound] = useState(false)
  const [showReview, setShowReview] = useState(false)

  useEffect(() => {
    validateBranch()
  }, [])

  useEffect(() => {
    if (searchValue) {
      setFilteredData(
        sectionData.filter((file_name) =>
          file_name.toLowerCase().includes(searchValue?.toLowerCase())
        )
      )
    } else {
      setFilteredData([...sectionData])
    }
  }, [sectionData, debouncedToSearchValue])

  const validateBranch = async () => {
    navDispatch({
      type: 'loader',
      data: {
        caption: 'Validating branch with git ...',
        showLoader: true,
      },
      notification: {},
    })
    let res = await getRequest(
      `/api/tracer/preview/validate/?data_version=${searchParams.get('data_version') ? searchParams.get('data_version') : ''}`
    )
    if (res?.data) {
      getMakeModalFileDetails(true)
    } else {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: 'Branch not available in git, please push selected make model to git.',
        },
      })
      setBarnchNotFound(true)
    }
  }

  const getMakeModalFileDetails = async (showLoader = true) => {
    if (showLoader) {
      navDispatch({
        type: 'loader',
        data: {
          caption: 'Loading Data ...',
          showLoader: true,
        },
        notification: {},
      })
    }

    let res = await getRequest(
      `/api/delete/promoted-files/vehicle-details/${vehicle}/`
    )
    if (showLoader) {
      navDispatch({
        type: 'loader',
        data: {},
        notification: {},
      })
    }

    dispatch({
      type: 'set_selected_files',
      data: {
        promoted_folder_data: res?.data?.section_data,
        is_exists: res?.data?.is_exists,
      },
    })

    Object.keys(res?.data?.section_data).map((section_key, sectionIdx) => {
      if (res?.data?.section_data[section_key].length > 0) {
        setSection(section_key)
        setSectionData([...res?.data?.section_data[section_key]])
      }
    })
  }

  const selectDeselectFolders = async (file_name, folder_name) => {
    let tempSelectedFolders = { ...selectedFolders }

    let tempIndex = tempSelectedFolders?.[folder_name]?.indexOf(file_name)

    if (tempIndex > -1) {
      tempSelectedFolders?.[folder_name].splice(tempIndex, 1)
    } else {
      tempSelectedFolders?.[folder_name].push(file_name)
    }

    setSelectedFolders(tempSelectedFolders)
  }

  const selectAllFileFromFolder = (selectAllValue, folder_name) => {
    let tempSelectedFolders = { ...selectedFolders }

    if (selectAllValue) {
      tempSelectedFolders[folder_name] =
        state?.selectedFiles.promoted_folder_data[folder_name].map((obj) => obj)
    } else {
      tempSelectedFolders[folder_name] = []
    }

    setSelectedFolders(tempSelectedFolders)
  }

  const deleteSelectedFilesAndFolders = async () => {
    if (
      window.confirm(
        `Are you sure want to delete selected files, after this you can't rollback it.`
      ) === true
    ) {
      navDispatch({
        type: 'loader',
        data: {
          caption: 'Deleting Selected Files ...',
          showLoader: true,
        },
        notification: {},
      })

      let payload = {
        selected_folder: selectedFolders,
      }
      let res = await postRequest(
        `/api/delete/promoted-files/run/${vehicle}/`,
        payload
      )
      if (res?.status) {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: 'Files Successfully Deleted',
          },
        })

        getMakeModalFileDetails(false)
        setSelectAll(false)
        setSelectedFolders({
          connector_views: [],
          power_distribution: [],
          vehicle_views: [],
          visual_aid: [],
          device_layout: [],
        })
        setShowReview(false)
      } else {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: res?.data?.msg,
          },
        })
      }
    }
  }

  const clickToReview = (isReview = false) => {
    setShowReview(isReview)
    if (isReview) {
      if (selectedFolders?.power_distribution?.length > 0) {
        setSection('power_distribution')
        setSectionData([...selectedFolders?.['power_distribution']])
      } else if (selectedFolders?.connector_views?.length > 0) {
        setSection('connector_views')
        setSectionData([...selectedFolders?.['connector_views']])
      } else if (selectedFolders?.vehicle_views?.length > 0) {
        setSection('vehicle_views')
        setSectionData([...selectedFolders?.['vehicle_views']])
      } else if (selectedFolders?.visual_aid?.length > 0) {
        setSection('visual_aid')
        setSectionData([...selectedFolders?.['visual_aid']])
      } else if (selectedFolders?.device_layout?.length > 0) {
        setSection('device_layout')
        setSectionData([...selectedFolders?.['device_layout']])
      }
    } else {
      if (
        state?.selectedFiles.promoted_folder_data?.power_distribution?.length >
        0
      ) {
        setSection('power_distribution')
        setSectionData([
          ...state?.selectedFiles.promoted_folder_data?.['power_distribution'],
        ])
      } else if (
        state?.selectedFiles.promoted_folder_data?.connector_views?.length > 0
      ) {
        setSection('connector_views')
        setSectionData([
          ...state?.selectedFiles.promoted_folder_data?.['connector_views'],
        ])
      } else if (
        state?.selectedFiles.promoted_folder_data?.vehicle_views?.length > 0
      ) {
        setSection('vehicle_views')
        setSectionData([
          ...state?.selectedFiles.promoted_folder_data?.['vehicle_views'],
        ])
      } else if (
        state?.selectedFiles.promoted_folder_data?.visual_aid?.length > 0
      ) {
        setSection('visual_aid')
        setSectionData([
          ...state?.selectedFiles.promoted_folder_data?.['visual_aid'],
        ])
      } else if (
        state?.selectedFiles.promoted_folder_data?.device_layout?.length > 0
      ) {
        setSection('device_layout')
        setSectionData([
          ...state?.selectedFiles.promoted_folder_data?.['device_layout'],
        ])
      }
    }
  }

  return (
    <>
      {showBarnchNotFound ? (
        <div className="flex flex-col py-3 space-y-6 w-full p-3">
          <ErrorCard
            sub_title={`Branch not exists in git so you can't perform this operation now.`}
            title={`Branch Not Found!`}
          />
        </div>
      ) : (
        <>
          {state?.selectedFiles.promoted_folder_data?.connector_views?.length ==
            0 &&
          state?.selectedFiles.promoted_folder_data?.power_distribution
            ?.length == 0 &&
          state?.selectedFiles.promoted_folder_data?.vehicle_views?.length ==
            0 &&
          state?.selectedFiles.promoted_folder_data?.visual_aid?.length == 0 &&
          state?.selectedFiles.promoted_folder_data?.device_layout?.length ==
            0 ? (
            <div className="flex flex-col py-3 space-y-2 w-full">
              <ErrorCard
                sub_title={`Connector View, Power Distribution, Vehicle View Data not exists. `}
                title={`Data Not Found!`}
              />
            </div>
          ) : (
            <div className="flex flex-col py-3 space-y-2 w-full">
              {state?.selectedFiles?.is_exists && (
                <DownloadDeleteFileLogBtn isBtn={true} vehicle={vehicle} />
              )}

              <div className="bg-white p-3 rounded-t">
                <div className="flex flex-row flex-wrap text-black text-lg">
                  {showReview ? (
                    <>
                      <div
                        className={`py-2 text-lg border-b border-white w-full`}
                      >
                        {(selectedFolders?.connector_views?.length > 0 ||
                          selectedFolders.power_distribution?.length > 0 ||
                          selectedFolders.vehicle_views?.length > 0 ||
                          selectedFolders.visual_aid?.length > 0 ||
                          selectedFolders.device_layout?.length > 0) && (
                          <>
                            <div className="flex flex-row flex-wrap text-lg">
                              {selectedFolders &&
                                Object.keys(selectedFolders)?.map(
                                  (key, folderIdx) => {
                                    return selectedFolders[key]?.length ? (
                                      <div
                                        className="flex w-1/4 py-1"
                                        key={`folder-${key}-${folderIdx}`}
                                      >
                                        <div
                                          className={`px-2 flex w-full`}
                                          onClick={() => {
                                            setSelectAll(false)
                                            if (key === section) {
                                              setSection(null)
                                              setSectionData([])
                                            } else {
                                              setSection(key)
                                              setSectionData([
                                                ...selectedFolders?.[key],
                                              ])
                                            }
                                          }}
                                        >
                                          <>
                                            <RadioButton
                                              name={'section'}
                                              checked={section === key}
                                              onChange={(e) => {
                                                if (e.target.checked) {
                                                  setSection(null)
                                                  setSectionData([])
                                                } else {
                                                  setSection(key)
                                                  setSectionData([
                                                    ...selectedFolders?.[key],
                                                  ])
                                                }
                                              }}
                                              value={section === key}
                                            />
                                            <span className="px-2 cursor-pointer">
                                              {key}
                                            </span>
                                          </>
                                        </div>
                                      </div>
                                    ) : (
                                      <></>
                                    )
                                  }
                                )}
                            </div>
                          </>
                        )}
                      </div>
                    </>
                  ) : (
                    state?.selectedFiles?.promoted_folder_data &&
                    Object.keys(
                      state?.selectedFiles?.promoted_folder_data
                    )?.map((key, vehicleIdx) => {
                      return state?.selectedFiles?.promoted_folder_data[key]
                        ?.length > 0 ? (
                        <div className="flex w-1/4 py-1" key={`vehicle-${key}`}>
                          <div className="px-2 flex items-center">
                            <RadioButton
                              name={'section'}
                              checked={section === key}
                              onChange={(e) => {
                                if (e?.target?.checked) {
                                  setSection(key)
                                  setSectionData([
                                    ...state?.selectedFiles
                                      ?.promoted_folder_data[key],
                                  ])
                                } else {
                                  setSection(null)
                                  setSectionData([])
                                }
                                setSelectAll(false)
                              }}
                            />
                            <span
                              className="px-2 cursor-pointer"
                              onClick={() => {
                                if (key === section) {
                                  setSection(null)
                                  setSectionData([])
                                } else {
                                  setSection(key)
                                  setSectionData([
                                    ...state?.selectedFiles
                                      ?.promoted_folder_data[key],
                                  ])
                                }
                              }}
                            >
                              {key}
                            </span>
                          </div>
                        </div>
                      ) : (
                        <></>
                      )
                    })
                  )}
                  {}
                </div>

                {section && (
                  <div>
                    <div className="border-b text-white border-t border-black my-3 bg-tracer-darkest-blue">
                      <div className="flex justify-between items-center mx-2">
                        <div className="flex w-full justify-start items-center gap-3">
                          <div className={`flex`}>
                            <CheckBox
                              onChange={(e) => {
                                setSelectAll(e?.target?.checked)
                                selectAllFileFromFolder(
                                  e?.target?.checked,
                                  section
                                )
                              }}
                              checked={selectAll}
                            />
                            <span className="px-2">Select All</span>
                          </div>
                          <div>View {section} files from here</div>
                        </div>

                        <InputText
                          name="search_value"
                          placeholder={`Search ${section} ....`}
                          className={`w-auto`}
                          value={searchValue}
                          isFullSize={true}
                          type="search"
                          onChange={(value) => {
                            setSearchValue(value)
                          }}
                          isRequired={false}
                          wrapperClass={`pl-0`}
                        />
                        <span
                          className="text-3xl cursor-pointer"
                          onClick={() => {
                            setSection(null)
                          }}
                        >
                          &times;
                        </span>
                      </div>
                    </div>
                    <div
                      className="relative overflow-y-scroll "
                      style={{ maxHeight: '50vh' }}
                    >
                      <div className="flex flex-row flex-wrap  text-base ">
                        {filteredData
                          .sort()
                          .slice(0, filteredData?.length)
                          .map((file_name, sectionIdx) => {
                            return (
                              <div
                                className="flex w-1/4 py-1"
                                key={`section-${file_name}-${sectionIdx}`}
                              >
                                <div className="px-2 flex items-center w-full">
                                  {selectedFolders?.[section]?.includes(
                                    file_name
                                  ) ? (
                                    <CheckCircle
                                      size="1rem"
                                      color="text-green-600"
                                      className="text-green-600 cursor-pointer"
                                      onClick={() => {
                                        selectDeselectFolders(
                                          file_name,
                                          section
                                        )
                                      }}
                                    />
                                  ) : (
                                    <Trash
                                      size="1rem"
                                      color="red"
                                      className="cursor-pointer"
                                      onClick={() => {
                                        selectDeselectFolders(
                                          file_name,
                                          section
                                        )
                                      }}
                                    />
                                  )}

                                  <div className="table_text w-3/4">
                                    <Tooltip message={file_name}>
                                      <span className="px-2 w-full">
                                        {file_name}
                                      </span>
                                    </Tooltip>
                                  </div>
                                </div>
                              </div>
                            )
                          })}
                      </div>

                      {sectionData?.length === 0 && <NoRecordsFound />}
                    </div>
                  </div>
                )}

                <div className="flex flex-row flex-wrap justify-between w-full items-center">
                  <div>
                    {section && (
                      <div className="">
                        Total {section} Selected :-{' '}
                        {selectedFolders?.[section]?.length}
                      </div>
                    )}
                  </div>
                  <div className="flex gap-2">
                    {showReview ? (
                      <>
                        <Button
                          type="submit"
                          className={`cursor-pointer btn ${selectedFolders?.connector_views?.length > 0 || selectedFolders?.vehicle_views?.length > 0 || selectedFolders?.visual_aid?.length > 0 || selectedFolders?.power_distribution?.length > 0 || selectedFolders?.device_layout?.length > 0 ? '' : 'disabled'}`}
                          text={'Re Select Files'}
                          onClick={() => {
                            clickToReview(false)
                          }}
                        />
                        <Button
                          type="submit"
                          className={`cursor-pointer btn ${selectedFolders?.connector_views?.length > 0 || selectedFolders?.vehicle_views?.length > 0 || selectedFolders?.visual_aid?.length > 0 || selectedFolders?.power_distribution?.length > 0 || selectedFolders?.device_layout?.length > 0 ? '' : 'disabled'}`}
                          text={'Delete Selected Files'}
                          onClick={() => {
                            deleteSelectedFilesAndFolders()
                          }}
                        />
                      </>
                    ) : (
                      <Button
                        type="submit"
                        className={`cursor-pointer btn ${selectedFolders?.connector_views?.length > 0 || selectedFolders?.vehicle_views?.length > 0 || selectedFolders?.visual_aid?.length > 0 || selectedFolders?.power_distribution?.length > 0 || selectedFolders?.device_layout?.length > 0 ? '' : 'disabled'}`}
                        text={'Review'}
                        onClick={() => {
                          clickToReview(true)
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  )
}

export default DeletePromotedFiles
